export default "__VITE_ASSET__BFcFWiys__"